import Vue from 'vue'
import moment from 'moment';
moment.locale('es');

/**
 * Filtro para formatear fecha ejemplo: antes 2023-04-20 10:07:30 después: 20 de abril de 2023
 */
Vue.filter('formatDate', function (value) {
    return moment(value).format('LL');
})

